'use es6';

import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { List, Set as ImmutableSet } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import identity from 'transmute/identity';
import has from 'transmute/has';
import map from 'transmute/map';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { getId } from '../../../data/schemas/userSchema';
import { getUserLabel } from '../../../lib/user-logic';
import { jsx as _jsx } from "react/jsx-runtime";
const UserCheckbox = /*#__PURE__*/memo(({
  userId,
  label,
  checked,
  disabled,
  onChange
}) => {
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "right",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.permissions.specificPartitioning.selectedTeamMemberTooltip"
    }),
    disabled: !disabled,
    children: /*#__PURE__*/_jsx(Checkbox, {
      "data-test-id": `user-${userId}`,
      checked: checked,
      value: userId,
      disabled: disabled,
      onChange: onChange,
      paddingInlineEnd: "200",
      children: /*#__PURE__*/_jsx(TruncateString, {
        children: label
      })
    }, userId)
  });
});
const UserCheckboxGroup = ({
  userCollection = List(),
  selectedTeamMemberValues = ImmutableSet(),
  selectedValues = ImmutableSet(),
  onChange = identity
}) => {
  const onCheckboxChange = useCallback(({
    target
  }) => {
    const {
      checked,
      value: targetValue
    } = target;
    onChange({
      checked,
      value: parseInt(targetValue, 10)
    });
  }, [onChange]);
  const isSelectedTeamMember = userId => has(userId, selectedTeamMemberValues);
  const isSelected = userId => has(userId, selectedValues) || isSelectedTeamMember(userId);
  return /*#__PURE__*/_jsx(ToggleGroup, {
    name: "user-toggles",
    marginInlineStart: "400",
    children: map(user => {
      const userId = getId(user);
      return /*#__PURE__*/_jsx(UserCheckbox, {
        userId: userId,
        disabled: isSelectedTeamMember(userId),
        label: getUserLabel({
          user
        }),
        checked: isSelected(userId),
        onChange: onCheckboxChange
      }, userId);
    }, userCollection)
  });
};
UserCheckboxGroup.propTypes = {
  userCollection: ImmutablePropTypes.iterable,
  selectedTeamMemberValues: ImmutablePropTypes.set,
  selectedValues: ImmutablePropTypes.set,
  onChange: PropTypes.func
};
export default /*#__PURE__*/memo(UserCheckboxGroup);